<template>
  <el-footer>
    <el-row type="flex" justify="center">
      <div>
        <span class="copyright-text" v-html="($mq.resize && $mq.below('768px')) ? mobileText:text"></span>
      </div>
    </el-row>
  </el-footer>
</template>

<script>
export default {
  name: 'Footer',
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  components: {
  },
  data () {
    return {
      text: 'Copyright &copy; 2018 MyBeer (M) Sdn Bhd.',
      mobileText: 'Copyright &copy; 2018 MyBeer (M) Sdn Bhd.'
    }
  },
  mounted () {
    this.text = this.getText()
    this.mobileText = this.getText()
  },
  methods: {
    getText () {
      const d = new Date()
      return 'Copyright &copy; ' + d.getFullYear() + ' MyBeer (M) Sdn Bhd.'
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/styles/settings.scss";
.el-footer {
  color: $white-color;
  height: auto !important;
  padding: 6px;
  background-color: #363636;

  .copyright-text {
    font-size: 12px;
    display: block;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue